export const parseQuery = <T = string>(
  query: T extends (infer U)[]
    ? (U | string) | (U | string)[]
    : (T | string) | (T | string)[],
  into: 'string' | 'array' = 'string'
): T => {
  if (!query) return null
  if (into === 'string') return Array.isArray(query) ? query?.[0] : query
  return (Array.isArray(query) ? query : [query]) as T
}

export const getRouterBasePath = (path: string) => {
  if (!path) return null
  if (typeof path !== 'string') return path
  return path.replace(/^\/([^?\/]*).*$/, '$1')
}
